export default __webpack_public_path__ + "01877618576a198b0e6e8b6270aa1fb2.png";